import * as bootstrap from 'bootstrap'
import 'bootstrap-daterangepicker'
import 'bootstrap-daterangepicker/daterangepicker.css'
import 'datatables.net-bs5'
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css'
import 'datatables.net-rowgroup'
import * as _ from 'lodash'
import moment from 'moment'
import bootbox from 'bootbox'
import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'

moment.locale(globals.vars.locales)

var dataTable

var accountCurrency = 'EUR' // default
var sDate, eDate
var searchTimer
var currentEditedTransaction = {}
var multiAccounts = false
var favoritesAccounts = false
var offcanvasTransactionModal
var formEdited = false
var accountsToDisplay = []

const swArr: Array<string> = ['#filter_unpaid', '#filter_uncategorized', '#filter_stats_excluded', '#filter_balanceOnly', '#filter_income', '#filter_expenses', '#filter_pending']

const meta = 'transactions'
window[`fnc_${meta}`] = initTransactionsPage

document.addEventListener("loadPage", () => {
    const evMeta = document.querySelector('meta[name="eventListener"]')
    if (evMeta !== null && evMeta['content'] === meta) {
        document.addEventListener("appReady", () => {
            if (DEBUG) console.log((`Initializing ${meta} page`))
            window[`fnc_${meta}`]()
        })
    }
})


function fillTransactionEditModal(data) {
    $('#copy-transaction-btn').show()
    $('#delete-transaction-btn').show()
    $('#f_statistic').prop('checked', data.statistic)
    $('#f_paid').prop('checked', data.paid)
    $('#_id').val(data._id)
    $('#f_amount').val(parseFloat(data.transactionAmount.amount))

    $('#f_date').data('daterangepicker').setStartDate(moment(data.date.reported))

    $('#f_category').val(data.categoryId)
    $('#f_tags').val(data.tags)

    $('#f_account').val(data.accountId)
    $('#f_account').trigger('change')

    $('#f_comment').val(data.comment)
    $('#f_title').val(data.title)
    $('#f_receiver').val(data.receiver)
    $('#f_usage').val(data.usage)
    $('#f_duplicate').prop('checked', data.isDuplicate)
}


function initTransactionsPage() {
    var ranges = {}

    const s1 = global.i18n.t('transactions.dateRangePicker.customRanges.today', { returnObjects: true, value: [moment().toISOString(), moment().endOf('day').toISOString()] })
    const s2 = global.i18n.t('transactions.dateRangePicker.customRanges.yesterday', { returnObjects: true, value: [moment().subtract(1, 'days').toISOString(), moment().subtract(1, 'days').toISOString()] })
    const s3 = global.i18n.t('transactions.dateRangePicker.customRanges.this_week', { returnObjects: true, value: [moment().startOf('isoWeek').toISOString(), moment().endOf('isoWeek').toISOString()] })
    const s4 = global.i18n.t('transactions.dateRangePicker.customRanges.last_7d', { returnObjects: true, value:[moment().subtract(6, 'days').toISOString(), moment().endOf('day').toISOString()] })
    const s5 = global.i18n.t('transactions.dateRangePicker.customRanges.last_30d', { returnObjects: true, value:[moment().subtract(29, 'days').toISOString(), moment().endOf('day').toISOString()] })
    const s6 = global.i18n.t('transactions.dateRangePicker.customRanges.this_month', { returnObjects: true, value: [moment().startOf('month').toISOString(), moment().endOf('month').toISOString()] })
    const s7 = global.i18n.t('transactions.dateRangePicker.customRanges.last_month', { returnObjects: true, value: [moment().subtract(1, 'month').startOf('month').toISOString(), moment().subtract(1, 'month').endOf('month').toISOString()] })
    const s8 = global.i18n.t('transactions.dateRangePicker.customRanges.this_quarter', { returnObjects: true, value: [moment().startOf('quarter').toISOString(), moment().endOf('quarter').toISOString()] })
    const s9 = global.i18n.t('transactions.dateRangePicker.customRanges.this_year', { returnObjects: true, value: [moment().startOf('year').toISOString(), moment().endOf('year').toISOString()] })
    const s10 = global.i18n.t('transactions.dateRangePicker.customRanges.last_year', { returnObjects: true, value: [moment().subtract(1, 'year').startOf('year').toISOString(), moment().subtract(1, 'year').endOf('year').toISOString()] })

    ranges[s1.name] = _.map(s1.value.split(','), function(o) { return moment(o).toDate()})
    ranges[s2.name] = _.map(s2.value.split(','), function(o) { return moment(o).toDate()})
    ranges[s3.name] = _.map(s3.value.split(','), function(o) { return moment(o).toDate()})
    // ranges[s4.name] = _.map(s4.value.split(','), function(o) { return moment(o).toDate()})
    ranges[s5.name] = _.map(s5.value.split(','), function(o) { return moment(o).toDate()})
    ranges[s6.name] = _.map(s6.value.split(','), function(o) { return moment(o).toDate()})
    ranges[s7.name] = _.map(s7.value.split(','), function(o) { return moment(o).toDate()})
    //ranges[s8.name] = _.map(s8.value.split(','), function(o) { return moment(o).toDate()})
    ranges[s9.name] = _.map(s9.value.split(','), function(o) { return moment(o).toDate()})
    ranges[s10.name] = _.map(s10.value.split(','), function(o) { return moment(o).toDate()})
    
    const ps = helpers.appSettingsGet('transactionsStartTime')
    const pe = helpers.appSettingsGet('transactionsEndTime')

    sDate = ps !== null ? moment(ps).toDate() : moment().startOf('month').toDate()

    if (helpers.appSettingsGet('transactionsUntilToday') !== null)
        eDate = moment().endOf('day').toDate()
    else
        eDate = pe !== null ? moment(pe).toDate() : moment().endOf('month').toDate()


    // =========================================================================
    // Favorite accounts button
    // =========================================================================
    const fav = helpers.appSettingsGet('transactionsFavoriteAccountsOnly')

    if (fav !== null && fav == true) {
        favoritesAccounts = true
        accountsToDisplay = _.filter(globals.vars.userData.accounts, function(o){
            return o['favorite'] === true && o['archived'] === false
        })
        $('.tr-favorites-btn').find('i').removeClass('far').addClass('fas').css('color', '#ffdc6c') //addClass('text-warning')
    } else {
        favoritesAccounts = false
        accountsToDisplay = _.filter(globals.vars.userData.accounts, function(o){
            return o['archived'] === false
        })
        $('.tr-favorites-btn').find('i').addClass('far').removeClass('fas').css('color', 'inherit') //.removeClass('text-warning')
    }

    $('.tr-favorites-btn').off().on('click', function(e) {
        helpers.appSettingsSet({'transactionsFavoriteAccountsOnly': !favoritesAccounts})
        window.location.reload()
    })

    let cat_out = ''

    for (let i=0; i<globals.vars.userData.categories.length; i++) {
        cat_out += `<a class="dropdown-item category-filter" href="#" data-category-id="${globals.vars.userData.categories[i]._id}"><i class="cat-icon-list ${globals.vars.userData.categories[i].icon}"></i> ${globals.vars.userData.categories[i].name}</a>`
    }

    $('#category-select').append(cat_out)

    $('.category-filter').each(function(idx, obj) {
        $(this).off().on('click', function(e) {
            e.preventDefault()

            $('.category-filter.active').removeClass('active')
            $(this).addClass('active')

            const _f = $(this).attr('data-category-id')

            if (typeof _f === 'undefined') {
                helpers.appSettingsDelete('transactionsCategoryFilter')
                dataTable.column(11).search('')
                $('.categories-btn').removeClass('btn-warning').addClass('btn-primary')
            } else {
                helpers.appSettingsSet({'transactionsCategoryFilter': _f})
                dataTable.column(11).search(_f, {exact: true})
                $('.categories-btn').removeClass('btn-primary').addClass('btn-warning')
                //console.log(dataTable.column( 12 ).data().sum());
            }

            dataTable.draw('full-hold')
        })
    })

    $('#refreshBtn').off().on('click', function(e) {
        e.preventDefault()

        _.map(swArr, function(o) {
            $(o).prop('checked', false)
        })

        $('#activeFilters').text('')

        helpers.appSettingsDelete('transactionsFilters')
        helpers.appSettingsDelete('transactionsCategoryFilter')
        dataTable.column(11).search('')
        $('.categories-btn').removeClass('btn-warning').addClass('btn-primary')

        dataTable.ajax.reload()
        
        applyDataFilters()
    })

    $('#f_date').daterangepicker({
        startDate: null,
        maxDate: moment().add('2 months').endOf('month'),
        singleDatePicker: true,
        timePicker: true,
        timePicker24Hour: true,
        timePickerSeconds: true,
        opens: "right",
        drops: "auto",
        autoApply: true,
        showDropdowns: true,
        buttonClasses: ['btn', 'btn-sm'],
        applyClass: 'btn-primary',
        cancelClass: 'btn-light',
        locale: {
            format: "YYYY-MM-DD HH:mm:ss",
            fromLabel: global.i18n.t('transactions.dateRangePicker.from'),
            toLabel: global.i18n.t('transactions.dateRangePicker.to'),
            applyLabel: global.i18n.t('buttons.apply'),
            cancelLabel: global.i18n.t('buttons.cancel'),
            customRangeLabel: global.i18n.t('transactions.dateRangePicker.custom'),
            daysOfWeek: global.i18n.t('transactions.dateRangePicker.daysOfWeek', { returnObjects: true }),
            monthNames: global.i18n.t('transactions.dateRangePicker.monthNames', { returnObjects: true }),
            firstDay: 1
        }
    }, function(start) {
        //console.log(moment(start).toISOString())
       
    })

    $('#reportrange').daterangepicker({
        format: 'DD/MM/YYYY',
        startDate: sDate,
        endDate: eDate,
        maxDate: moment().endOf('year'),
        ranges: ranges,
        linkedCalendars: false,
        showCustomRangeLabel: false,
        alwaysShowCalendars: true,
        opens: "right",
        drops: "auto",
        autoApply: true,
        showDropdowns: true,
        buttonClasses: ['btn', 'btn-sm'],
        applyClass: 'btn-success',
        cancelClass: 'btn-secondary',
        locale: {
            fromLabel: global.i18n.t('transactions.dateRangePicker.from'),
            toLabel: global.i18n.t('transactions.dateRangePicker.to'),
            customRangeLabel: global.i18n.t('transactions.dateRangePicker.custom'),
            daysOfWeek: global.i18n.t('transactions.dateRangePicker.daysOfWeek', { returnObjects: true }),
            monthNames: global.i18n.t('transactions.dateRangePicker.monthNames', { returnObjects: true }),
            firstDay: 1
        }
    }, function(start, end, label) {
        //console.log('New date range selected: ' + start.format('YYYY-MM-DD HH:mm') + ' to ' + end.format('YYYY-MM-DD HH:mm') + ' (predefined range: ' + label + ')')

        sDate = start.toDate()
        eDate = end.toDate()

        helpers.appSettingsSet({'transactionsStartTime': sDate.toISOString()})
        helpers.appSettingsSet({'transactionsEndTime': eDate.toISOString()})

        if (moment(end).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')) {
            helpers.appSettingsSet({'transactionsUntilToday': true})
        } else {
             helpers.appSettingsDelete('transactionsUntilToday')
        }

        $('#reportrange span').html(`${global.i18n.t('transactions.dateRangePicker.from')} ${new Date(sDate).toLocaleDateString(globals.vars.locales)} ${global.i18n.t('transactions.dateRangePicker.to')} ${new Date(eDate).toLocaleDateString(globals.vars.locales)}`)
  
        refreshUI()
    })

    $('#reportrange span').html(`${global.i18n.t('transactions.dateRangePicker.from')} ${new Date(sDate).toLocaleDateString(globals.vars.locales)} ${global.i18n.t('transactions.dateRangePicker.to')} ${new Date(eDate).toLocaleDateString(globals.vars.locales)}`)


    const select2Data = []

    for (let i=0; i<accountsToDisplay.length; i++) {
        select2Data.push({
            id: accountsToDisplay[i]._id,
            text: accountsToDisplay[i].custom_name != '' ? accountsToDisplay[i].custom_name : accountsToDisplay[i].name,
        })
    }
   
    $('#f_account').select2({
        tags: false,
        dropdownParent: $('#offcanvasTransaction'),
        data: _.map(_.filter(globals.vars.userData.accounts, function(o) {
            return o['archived'] == false
        }), function(p) {
            return { id: p['_id'], text: p['custom_name'] != '' ? p['custom_name'] : p['name']}
        })
    })

    $('[id^="f_"]').each(function() {
        $(this).on('change', function(e) {
            formEdited = true
        })
    })

    const accountsToDisplayById = {}
    _.map(accountsToDisplay, function(o) {
        accountsToDisplayById[o['_id']] = o
    })

    select2Data.unshift({  // all accounts
        id: '@'+btoa(Object.keys(accountsToDisplayById).join('|')),
        text: favoritesAccounts ? global.i18n.t('transactions.all_favorites') : global.i18n.t('transactions.all_accounts')
    })

    function formatFirst (item) {
        if (!item.id) {
            return item.text;
        }

        if (item.id.charAt(0) == '@')
            return $(`<span class="first">${item.text}</span>`)
        else
            return item.text
      };

    $('.account-select').select2({
        tags: false,
        data: select2Data,
        templateResult: formatFirst
    })

    if (accountsToDisplay.length > 0) {
        const _prev = helpers.appSettingsGet('transactionsAccountId')

        if (_prev && typeof accountsToDisplayById[_prev] !== 'undefined')
            $('.account-select').val(_prev)
        else
            $('.account-select').val([select2Data[0].id])
        
        $('.account-select').trigger('change')
    }

    if ($('.account-select').val()[0] == '@') {
        multiAccounts = true
        $('.hidden-if-all').addClass('visually-hidden')
    }

    $('.account-select').on('select2:select', function (e) {
        var data = e.params.data
        helpers.appSettingsSet({'transactionsAccountId': data.id} )

        if (data.id[0] == '@') {
            multiAccounts = true
            $('.hidden-if-all').addClass('visually-hidden')
            helpers.appSettingsDelete('transactionsAccountId')
        } else {
            multiAccounts = false
            $('.hidden-if-all').removeClass('visually-hidden')
        }

        refreshUI()
    })

    $('#clearSearchBtn').off().on('click', function(e) {
        e.preventDefault()
        e.stopImmediatePropagation()
        $('.searchInput').val('')
        $('.searchInput-btn').removeClass('btn-warning').addClass('btn-primary')
        
        //dataTable.column(3).search('').draw('full-hold')
        dataTable.search('').draw('full-hold')

        $('.searchInput').focus()
    })

    $('.searchInput-btn').on('click', function(e) {
        $('.searchInput').select()
        $('.searchInput').focus()
    })

    $('.searchInput').keyup(function(key) {
        clearTimeout(searchTimer)

        if ($('.searchInput').val() !== '')
            $('.searchInput-btn').removeClass('btn-primary').addClass('btn-warning')
        else
            $('.searchInput-btn').removeClass('btn-warning').addClass('btn-primary')

        searchTimer = setTimeout(function() {
            //dataTable.column(3).search($('.searchInput').val(), false, true).draw('full-hold')
            dataTable.search($('.searchInput').val(), false, true).draw('full-hold')
        }, 250)
    })

    $('#delete-transaction-btn').off().on('click', function(e) {
        e.preventDefault()

        bootbox.confirm({
            message: global.i18n.t('transactions.transactionEdit.delete_confirmation'),
            centerVertical: true,
            buttons: {
                confirm: {
                label:  global.i18n.t('transactions.transactionEdit.yes'),
                className: 'btn-danger'
                },
                cancel: {
                    label: global.i18n.t('transactions.transactionEdit.no'),
                    className: 'btn-light'
                }
            },
            callback: function (result) {
                if (!result)
                    return
    
                const params = {
                    item: {
                        _id: currentEditedTransaction['_id']
                    },
                    _csrf: $("meta[name=_csrf]").attr("content")
                }

                $.ajax({
                    url: '/json/transaction/delete',
                    method: 'POST',
                    data: params,
                    success: function (response) {
                        if (typeof response['error'] !== 'undefined') {
                            helpers.alert(response)
                        }

                        if (DEBUG) console.log(response)

                        setTimeout(function() {
                            offcanvasTransactionModal.hide()
                        }, 100) 

                        dataTable.ajax.reload().draw('full-hold')       
                    },
                    error: function (err) {
                        helpers.alert(err)
                    }
                })
            }
        })
    })

    $('#copy-transaction-btn').off().on('click', function(e) {
        e.preventDefault()

        // const _arr = ['title', 'receiver', 'usage', 'comment']

        // for (let i=0; i<_arr.length; i++) {
        //     if (currentEditedTransaction[_arr[i]] != '') {
        //         currentEditedTransaction[_arr[i]] = currentEditedTransaction[_arr[i]]
        //         break
        //     }
        // }
  

        currentEditedTransaction['_id'] = ''
        currentEditedTransaction['uniqId'] = crypto.randomUUID()
        currentEditedTransaction['date']['booked'] = moment(currentEditedTransaction['date']['booked']).add(1, 'second').toISOString()
        currentEditedTransaction['date']['reported'] = moment(currentEditedTransaction['date']['reported']).add(1, 'second').toISOString()

        const params = {
            item: currentEditedTransaction,
            _csrf: $("meta[name=_csrf]").attr("content")
        }
   
        $.ajax({
            url: '/json/transaction/insert',
            method: 'POST',
            data: params,
            success: function (response) {
                if (typeof response['error'] !== 'undefined') {
                    helpers.alert(response)
                }

                if (DEBUG) console.log(response)
                
                offcanvasTransactionModal.hide()
                dataTable.ajax.reload().draw('full-hold')
                
                bootbox.confirm({
                    message: global.i18n.t('transactions.transactionEdit.edit_after_copy'),
                    centerVertical: true,
                    buttons: {
                        confirm: {
                        label:  global.i18n.t('transactions.transactionEdit.yes'),
                        className: 'btn-primary'
                        },
                        cancel: {
                            label: global.i18n.t('transactions.transactionEdit.no'),
                            className: 'btn-light'
                        }
                    },
                    callback: function (result) {
                        if (!result)
                            return

                        currentEditedTransaction['_id'] = response['insertedId']
                        fillTransactionEditModal(currentEditedTransaction)
                        offcanvasTransactionModal.show()
                    }
                })
            },
            error: function (err) {
                helpers.alert(err)
            }
        })
    })

    refreshUI()
}


//ANCHOR - refreshBalanceSheet
function refreshBalanceSheet(json) {
    const data: Array<unknown> = json.aaData //dataTable.rows().data()
    const stats = json.stats
    
    /** calculated account balance **/
    $('#sDate').text(sDate.toLocaleDateString(globals.vars.locales))
    $('#eDate').text(eDate.toLocaleDateString(globals.vars.locales))

    const sBal = parseFloat(stats['startBalance'])
    const eBal = parseFloat(stats['endBalance'])

    $('#sBalance').text(
        helpers.anonFigures( helpers.fmtCurrency(sBal, accountCurrency) )
    )

    $('#eBalance').text(
        helpers.anonFigures( helpers.fmtCurrency(eBal, accountCurrency) )
    )

    if (sBal >= 0)
        $('#sBalance').removeClass('text-danger').addClass('text-success')
    else
        $('#sBalance').removeClass('text-success').addClass('text-danger')
    
    if (eBal >= 0)
        $('#eBalance').removeClass('text-danger').addClass('text-success')
    else
        $('#eBalance').removeClass('text-success').addClass('text-danger')

    //$('.dataTables_paginate > .pagination').addClass('pagination-rounded')
}

function applyDataFilters() {
    /** Filtering **/
    if ($('#filter_balanceOnly').prop('checked')) {  // if balance, disable other filters
        $('#filter_unpaid').prop('checked', false)
        $('#filter_uncategorized').prop('checked', false)
        $('#filter_income').prop('checked', false)
        $('#filter_expenses').prop('checked', false)
        $('#filter_pending').prop('checked', false)
        $('#filter_stats_excluded').prop('checked', false)
        dataTable.column(0).search('balance')
    } 

    if ($('#filter_uncategorized').prop('checked')) {
        dataTable.column(1).search('^$', true, false)
        dataTable.column(10).search('^false$', true, false)
    } else {
        dataTable.column(1).search('')
        dataTable.column(10).search('')
    }

    if ($('#filter_unpaid').prop('checked'))
        dataTable.column(0).search('^false$', true, false)

    if ($('#filter_stats_excluded').prop('checked'))
        dataTable.column(12).search('^true$', true, false)
    else
        dataTable.column(12).search('')
        
    if ($('#filter_income').prop('checked') && $('#filter_expenses').prop('checked')) {
        dataTable.column(8).search('')
    } else if ($('#filter_income').prop('checked')) { 
        dataTable.column(8).search('i', false, false)
    } else if ($('#filter_expenses').prop('checked')) {
        dataTable.column(8).search('e', false, false)
    } else {
        dataTable.column(8).search('')
    }

    if ($('#filter_pending').prop('checked'))
        dataTable.column(9).search('^true$', true, false)
    else
        dataTable.column(9).search('')

    const ckc = _.filter(swArr, function(o) {
        return $(o).prop('checked')
    })

    if (ckc.length > 0)
        $('.filters-btn').removeClass('btn-primary').addClass('btn-warning')
    else
        $('.filters-btn').removeClass('btn-warning').addClass('btn-primary')


    if (!$('#filter_balanceOnly').prop('checked') && !$('#filter_unpaid').prop('checked'))
        dataTable.column(0).search('')

    dataTable.draw('full-hold')
}

function refreshUI() {
    if ($('.account-select').val()[0] == '@') {
        $('#onlineAccountBalancesContainer').addClass('visually-hidden')

        if (typeof dataTable === 'undefined')
            return initDataTable()
        else
             return dataTable.ajax.reload().draw('full-hold')
    }

    if (typeof dataTable === 'undefined')
        initDataTable()
    else
        dataTable.ajax.reload().draw('full-hold')

    let _lastChecked = '<unknown>'

    const selected_account = $('.account-select').val()

    const account = globals.vars.userData.accountsById[selected_account]
   
    accountCurrency = account.currency

    if (accountCurrency == 'XXX')
        accountCurrency = 'EUR'

    let _cd
    if (typeof account.last_polled_on !== 'undefined') {
        _cd = new Date(account.last_polled_on)
        _lastChecked = `${_cd.toLocaleDateString(globals.vars.locales)} ${global.i18n.t('transactions.synced_at')} ${_cd.toLocaleTimeString(globals.vars.locales)}`
    }
    
    if (typeof account.data.balances !== 'undefined' && account.data.balances.length > 0) {
        let output = ''

        for (let i=0; i<account.data.balances.length; i++) {
            const item = account.data.balances[i]

            const _d = typeof item.referenceDate !== 'undefined' ? new Date(item.referenceDate).toLocaleDateString(globals.vars.locales) : typeof _cd !== 'undefined' ? _cd.toLocaleDateString(globals.vars.locales) : ''
            const _b = parseFloat(item.balanceAmount.amount)
            const _c = item.balanceAmount.currency
            const _t = item.balanceType

            const cls = _b >= 0 ? 'text-success' : 'text-danger'

            const _a = helpers.anonFigures( helpers.fmtCurrency(parseFloat(_b.toFixed(2)), _c) )
            

            output += `
                <div class="d-flex border-bottom">
                    <div class="flex-grow-1 justify-content-start">${_d}</div>
                    <div class="justify-content-end text-muted">${_t}</div>
                </div>
                <div class="d-flex pb-2 pt-1">
                    <div class="flex-grow-1 justify-content-start fw-bold"></div>
                    <div class="justify-content-end fw-bold ${cls} amount">${_a}</div>
                </div>
            `
        }

        output += `<div class="row fs-6 justify-content-center pt-3 text-muted">${global.i18n.t('transactions.synced_on')} ${_lastChecked}</div>`

        $('#onlineAccountBalances').html(output)           
        $('#onlineAccountBalancesContainer').removeClass('visually-hidden')
    } else {
        $('#onlineAccountBalancesContainer').addClass('visually-hidden')
    }
}

function initDataTable() {
    //ANCHOR - DataTable
    let noBalance = false
    dataTable =  $('#transactions-datatable')
    .on('xhr.dt', function (e, settings, json, xhr) {
        // json.aaData = _.filter(json.aaData, function(o) {
        //     return o['_id'] !== 'int-fake'
        // })

        refreshBalanceSheet(json)
    })
    .DataTable({
        //scrollCollapse: true,
        //scrollY: '50vh',
        //dom: "<'row mt-3'<'col-sm-12 col-md-4 d-flex justify-content-start'<'w-100'f>><'d-none d-sm-none d-md-inline-flex col-md-8 d-flex text-primary justify-content-end nowrap'<B><>>>" +
        dom: "" +
        "<'row'<'col-sm-12't>>r" +
        "<'row'<'col-sm-12 d-flex mt-1 justify-content-end'p>>",
        language: {
            paginate: {
                previous: "<i class='mdi mdi-chevron-left'>",
                next: "<i class='mdi mdi-chevron-right'>"
            },
            search: '<div class="input-group input-group-sm"><span class="input-group-text"><i class="fe-search"></i></span>',


            lengthMenu: '<select class="form-control form-control-sm no-lock">'+
                                '<option value="25" selected>25</option>'+
                                '<option value="50">50</option>'+
                                '<option value="100">100</option>'+
                                '<option value="250">250</option>'+
                            '</select>',
            processing: '<div class="text-center"><div class="spinner-grow text-primary m-2" role="status"></div><div class="spinner-grow text-warning m-2" role="status"></div><div class="spinner-grow text-danger m-2" role="status"></div></div>',
            emptyTable: `<div class="text-center"><i class="mdi mdi-database-remove fa-10x text-muted"></i><span class="text-muted fs-2">${global.i18n.t('transactions.datatables.no_data')}</span></div>`,
            zeroRecords: `<div class="text-center"><i class="mdi mdi-database-remove fa-10x text-muted"></i><span class="text-muted fs-2">${global.i18n.t('transactions.datatables.no_data')}</span></div>`,
            infoFiltered: '',
            loadingRecords: global.i18n.t('transactions.datatables.loading'),
        },
        //buttons: ['copyHtml5', 'excelHtml5', 'csvHtml5', 'pdfHtml5'],
        lengthChange: false,
        pageLength: 25,
        paging: false,
	    deferRender: true,
        serverSide: false,
        processing: true,
        drawCallback: function (settings) {
            // @ts-ignore
            var api = this.api()

            //const _arr = api.column(12, {page: 'current'}).data()

            const _arr = api.rows({ page: 'current' }).data();

            const _sel = _.filter(_arr, function(o) {
                return o.paid === true && o.isDuplicate === false && o.statistic === true && o.pending === false
                    && ( o.categoryId === '' || (typeof globals.vars.userData.categoriesById[o.categoryId] !== 'undefined' && globals.vars.userData.categoriesById[o.categoryId]['statistics'] === true))
                    && (!multiAccounts || globals.vars.userData.accountsById[o.accountId]['statistic'] === true)
            })

            const _amount = _.sum(_.map(_sel, function(o) {
                return parseFloat(o['transactionAmount']['amount']) || 0
            }))

            const cls = _amount >= 0 ? 'text-success' : 'text-danger'

            const _val = helpers.anonFigures((_amount > 0 ? '+' : '')+helpers.fmtCurrency(_amount, 'EUR'))
            const _out = `<span class="${cls} fw-bold text-nowrap fs-5">${_val}</span>`

            $('.view-sum').html(_out)

       
            const filteredIncome = _.sum(_.map(_sel, function(o) {
                const _v =  parseFloat(o['transactionAmount']['amount']) || 0
                return _v > 0 ? _v : 0
            }))
        
            const filteredExpenses = _.sum(_.map(_sel, function(o) {
                const _v =  parseFloat(o['transactionAmount']['amount']) || 0
                return _v < 0 ? _v : 0
            }))
        
            const outcome = filteredIncome + filteredExpenses

            $('#sum_income').text(
                helpers.anonFigures( helpers.fmtCurrency(filteredIncome, accountCurrency) )
            )
        
            $('#sum_expenses').text(
                helpers.anonFigures( helpers.fmtCurrency(filteredExpenses, accountCurrency) )
            )
        
            $('#outcome').text(
                helpers.anonFigures( helpers.fmtCurrency(outcome, accountCurrency) )
            )
        
            if (outcome > 0)
                $('#outcome').removeClass('text-danger').addClass('text-success')
            else
                $('#outcome').removeClass('text-success').addClass('text-danger')

            tippy('[data-plugin="tippy"]')
        },
        "footerCallback": function (row, data, start, end, display) {

        },
        rowCallback: function (row, data) {
            $('td:eq(0)', row).text('')
            if (data['isAccountBalance'] === true) {
                $('td:eq(0)', row).removeClass('bg-light').addClass('bg-purple')
                $('td:eq(1)', row).html('<i class="fas fa-balance-scale fa-2x text-purple"></i>')

                if (multiAccounts) {
                    const acc = globals.vars.userData.accountsById[data['accountId']]['custom_name'] !== '' ? globals.vars.userData.accountsById[data['accountId']]['custom_name'] : globals.vars.userData.accountsById[data['accountId']]['name']
                    $('td:eq(2)', row).html(`<div class="text-truncate text-primary">${acc}</div><div class="fw-bold text-truncate">${global.i18n.t("transactions.account_balance_l1")}</div><div class="text-muted fs-6 text-truncate">${global.i18n.t("transactions.account_balance_l2")}</div>`)
                    $('td:eq(3)', row).html(`<div class="text-truncate text-primary">${acc}</div><div class="fw-bold text-truncate">${global.i18n.t("transactions.account_balance_l1")}</div><div class="text-muted fs-6 text-truncate">${global.i18n.t("transactions.account_balance_l2")}</div>`)  
                } else {
                    $('td:eq(2)', row).html(`<div class="fw-bold text-truncate">${global.i18n.t("transactions.account_balance_l1")}</div><div class="text-muted fs-6 text-truncate">${global.i18n.t("transactions.account_balance_l2")}</div>`)
                    $('td:eq(3)', row).html(`<div class="fw-bold text-truncate">${global.i18n.t("transactions.account_balance_l1")}</div><div class="text-muted fs-6 text-truncate">${global.i18n.t("transactions.account_balance_l2")}</div>`)
                }

                $('td:eq(5)', row).find('div').removeClass('text-success').addClass('text-purple')
            } else {
                if (data['pending'] === false) {
                    if (data['paid'] === true)
                        $('td:eq(0)', row).removeClass('bg-light').addClass('bg-success')
                    else if (data['paid'] === false)
                        $('td:eq(0)', row).removeClass('bg-light').addClass('bg-danger')
                }

                if (data['categoryId'] == '' || typeof globals.vars.userData.categoriesById[data['categoryId']] === 'undefined')
                    $('td:eq(1)', row).html('<i class="fas fa-question-circle fa-2x text-muted"></i><i class="mdi mdi-chevron-down"></i>')
                else 
                    $('td:eq(1)', row).html(`<i class="${globals.vars.userData.categoriesById[data['categoryId']]['icon']} fa-2x text-muted"></i><i class="mdi mdi-chevron-down"></i>`)
            }
        },
        initComplete: function( oSettings ) {
            let needDraw = false

            const _catF = helpers.appSettingsGet('transactionsCategoryFilter')
            
            if (_catF !== null) {
                $('.category-filter.active').removeClass('active')
                $(`[data-category-id="${_catF}"]`).addClass('active')
                
                $('.categories-btn').removeClass('btn-primary').addClass('btn-warning')

                dataTable.column(11).search(_catF, {exact: true})
                needDraw = true
            }

            const filters = helpers.appSettingsGet('transactionsFilters')

            if (filters !== null && !_.isEmpty(filters)) {
                _.map(filters, function(o) {
                    $(o).prop('checked', true)
                })
                applyDataFilters()
            }

            if (needDraw)
                dataTable.draw('full-hold')
        },
        ajax: {
            url: '/json/dt.transactions',
            type: 'POST',
            data: function (d) {
                let _acc = []

                if ($('.account-select').val()[0] == '@') {
                    const _sel = $('.account-select').val() as string
                    _acc = atob(_sel.substring(1)).split('|')
                } else {
                    _acc = [$('.account-select').val() as string]
                }

                return $.extend({}, d, {
                    accounts: _acc,
                    sDate: sDate.toISOString(),
                    eDate: eDate.toISOString(),
                    includeDuplicates: $('#filter_duplicates').prop('checked'),
                    _csrf: $("meta[name=_csrf]").attr("content"),
                })
            }
        },
        rowGroup: {
            enable: $("meta[name=mobile-device]").attr("content") === 'true' ? true : true,
            dataSrc: 'reportedOn',
            startRender: function (rows, group) {
                const options: Intl.DateTimeFormatOptions = {
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  };
                  
                return `<div class="mt-4 mb-1 text-muted fs-6">${new Date(group).toLocaleDateString(globals.vars.locales, options)}</div>`
            },
            // endRender: function (rows, group) {
            //     return '&nbsp;'
            // },
            className: 'd-table-row d-sm-none transactions-group'
        },
        columns: [
            { // 0
                data: 'paid',
                className: "bg-light col-paid",
                orderable: false,
                render: function (data, type, row, meta) {
                    return row['isAccountBalance'] == true ? 'balance' : data.toString()
                },
            },
            { // 1
                data: "categoryId",
                className: "align-middle justify-content-center py-1 col-category",
                orderable: false,
                searchable: true,
                render: function (data, type, row, meta) {
                    return data
                },
            },
            { // 2
                data: null, // mobile version
                className: "d-table-cell d-sm-none custom-wrap-short ps-1 py-1 w-100",
                orderable: false,
                render: function (data, type, row, meta) {
                    let _arr = _.compact([row.title, row.receiver, row.usage, row.comment])

                    let l1 = _arr[0] || '&nbsp;'

                    if (row.isDuplicate)
                        l1 = '<i class="fas fa-clone text-pink fw-bold"></i> '+l1

                    if (row.pending)
                        l1 = '<i class="far fa-clock text-danger"></i> '+l1

                    if (parseFloat(row.transactionAmount.amount) == 0)
                        row.transactionAmount.amount = 0  // removes -0.00 from transactions

                    const cls = row.pending ? 'text-muted' : parseFloat(row.transactionAmount.amount) >= 0 ? 'text-success' : 'text-danger'

                    let value = helpers.fmtCurrency(parseFloat(row.transactionAmount.amount), row.transactionAmount.currency)

                    if (!row.statistic || row.pending || (multiAccounts && !globals.vars.userData.accountsById[row.accountId]['statistic']) || (typeof globals.vars.userData.categoriesById[row.categoryId] !== 'undefined' && !globals.vars.userData.categoriesById[row.categoryId]['statistics']))
                        value = `(${value})`

                    if (globals.vars.privacyMode)
                        value = helpers.anonFigures(value)

                    const date = new Date(row.date.reported).toLocaleDateString(globals.vars.locales)

                    let balance = typeof row.balance === 'undefined' ? globals.vars.userData.accountsById[row.accountId] :  helpers.fmtCurrency(parseFloat(row.balance), row.transactionAmount.currency)
                    
                    if (globals.vars.privacyMode)
                        balance = helpers.anonFigures(balance)

                    if (row.isDuplicate || row.pending)
                        balance = '--'

                    if (multiAccounts) {
                        const acc = globals.vars.userData.accountsById[row.accountId]['custom_name'] !== '' ? globals.vars.userData.accountsById[row.accountId]['custom_name'] : globals.vars.userData.accountsById[row.accountId]['name']
                    
                        return `
                            <div class="text-primary text-truncate">${acc}</div>

                            <div class="d-flex flex-row">
                                <div class="fw-bold text-truncate flex-grow-1">${l1}</div>
                                <div class="ms-1 ${cls} fw-bold float-end text-end amount">${value}</div>
                            </div>
                    `
                    } else {
                        return `
                            <div class="d-flex flex-row">
                                <div class="fw-bold text-truncate flex-grow-1">${l1}</div>
                            </div>
                            <div class="d-flex flex-row pe-1">
                                <div class="small text-muted flex-grow-1 amount">${balance}</div>
                                <div class="${cls} fw-bold float-end text-end amount">${value}</div>
                            </div>
                    `
                    }
                },
            },
            { // 3
                data: null,
                className: "d-none d-sm-table-cell custom-wrap px-0 py-1 w-100 ps-2",
                orderable: false,
                render: function (data, type, row, meta) {
                    let _arr = _.compact([row.title, row.receiver, row.usage, row.comment])

                    let l1 = _arr[0] || '&nbsp;'
                    let l2 = _arr.length > 1 ? _arr[1] : row.tags.length > 0 ? '#'+row.tags.join(' #') : '&nbsp;'

                    if (row.isDuplicate)
                        l1 = '<i class="fas fa-clone text-pink fw-bold"></i> '+l1

                    if (row.pending)
                        l1 = '<i class="far fa-clock text-danger"></i> '+l1

                    if (multiAccounts) {
                        const acc = globals.vars.userData.accountsById[row.accountId]['custom_name'] !== '' ? globals.vars.userData.accountsById[row.accountId]['custom_name'] : globals.vars.userData.accountsById[row.accountId]['name']
                    
                        return `
                            <div class="text-primary text-truncate">${acc}</div>
                            <div class="fw-bold text-truncate">${l1}</div>
                            <div class="text-muted fs-6 text-truncate">${l2}</div>
                    `
                    } else {
                        return `
                            <div class="fw-bold text-truncate">${l1}</div>
                            <div class="text-muted fs-6 text-truncate">${l2}</div>
                    `
                    }
                },
            },
            { // 4
                data: "tags",
                className: "d-none d-sm-table-cell tr-tag align-middle",
                orderable: false,
                visible: true,
                render: function (data, type, row, meta) {
                    return data.length > 0 ? `<div data-plugin="tippy" data-tippy-placement="top" data-tippy="" data-tippy-allowHTML="true" data-tippy-content="#${data.join('<br>#')}"><i class="fas fa-tags text-primary""></i></div>` : '<div><i class="fas fa-tags text-light"></i></div>'
                },
                defaultContent: '<div><i class="fas fa-tags text-light"></i></div>'
            },
            { // 5
                data: "transactionAmount",
                className: "d-none d-sm-table-cell text-truncate align-middle px-2 py-1",
                orderable: false,
                render: function (data, type, row, meta) {
                    if (parseFloat(data.amount) == 0)
                        data.amount = 0  // removes -0.00 from transactions

                    const cls = row.pending ? 'text-muted' : parseFloat(data.amount) >= 0 ? 'text-success' : 'text-danger'

                    let value = helpers.fmtCurrency(parseFloat(data.amount), data.currency)

                    if (!row.statistic || row.pending || (multiAccounts && !globals.vars.userData.accountsById[row.accountId]['statistic']) || (typeof globals.vars.userData.categoriesById[row.categoryId] !== 'undefined' && !globals.vars.userData.categoriesById[row.categoryId]['statistics']))
                        value = `(${value})`

                    if (globals.vars.privacyMode)
                        value = helpers.anonFigures(value)

                    return `<div class="row ${cls} fw-bold fs-5 justify-content-end mx-0 amount">${value}</div>`
                },
            },
            { // 6
                data: null,
                className: "d-none d-sm-table-cell text-nowrap align-middle px-2 py-1",
                orderable: false,
                render: function (data, type, row, meta) {
                    let l1 = typeof row.balance === 'undefined' ? globals.vars.userData.accountsById[row.accountId] :  helpers.fmtCurrency(parseFloat(row.balance), row.transactionAmount.currency)
                    const l2 = new Date(row.date.reported).toLocaleDateString(globals.vars.locales)
                    
                    if (globals.vars.privacyMode)
                        l1 = helpers.anonFigures(l1)

                    if (row.isDuplicate || row.pending)
                        l1 = '--'

                    return `
                        <div class="row text-muted justify-content-end mx-0 amount">${l1}</div>
                        <div class="row justify-content-end mx-0">${l2}</div>
                    `
                },

            },
            { // 7
                data: "idx", // for sort only
                type: "number",
                className: "",
                orderable: true,
                visible: false,
                render: function (data, type, row, meta) {
                    return data
                },
            },
            { // 8
                data: null, // for filtering expenses / income
                type: "string",
                className: "",
                orderable: false,
                visible: false,
                render: function (data, type, row, meta) {
                    return row.isAccountBalance == true ? '' : parseFloat(row.transactionAmount.amount) >= 0 ? 'i' : 'e'
                },
            },
            { // 9
                data: null, // for filtering pending
                type: "boolean",
                className: "",
                orderable: true,
                visible: false,
                render: function (data, type, row, meta) {
                    return row.pending
                },
            },
            { // 10
                data: null, // for filtering isAccountBalance
                type: "boolean",
                className: "",
                orderable: true,
                visible: false,
                render: function (data, type, row, meta) {
                    return row.isAccountBalance
                },
            },
            { // 11
                data: null, // for filtering categoryId
                type: "string",
                className: "",
                searchable: true,
                orderable: false,
                visible: false,
                render: function (data, type, row, meta) {
                    return row.categoryId
                },
            }
            ,
            { // 12
                data: null, // for filtering accounted values
                type: "boolean",
                className: "",
                searchable: true,
                orderable: false,
                visible: false,
                render: function (data, type, row, meta) {
                    if (!row.statistic || row.pending || (multiAccounts && !globals.vars.userData.accountsById[row.accountId]['statistic']) || (typeof globals.vars.userData.categoriesById[row.categoryId] !== 'undefined' && !globals.vars.userData.categoriesById[row.categoryId]['statistics']))
                        return false
                    else
                        return true
                },
            },
            { // 13 // for filtering
                data: "transactionAmount.amount",
                className: "d-none d-sm-table-cell text-truncate align-middle px-2 py-1",
                type: "numeric",
                orderable: false,
                visible: false,
                render: function (data, type, row, meta) {
                    return parseFloat(data).toFixed(2)
                },
            },
        ],
        order: [[9, 'desc'],[7, 'asc']],
        autoWidth: false,
        "columnDefs": [
            { "width": "5px", "targets": 0 },
            { "width": "30px", "targets": 1, },
            { "width": "30px", "targets": 3 },
            { "width": "50px", "targets": 4 },
            { "width": "50px", "targets": 5 }
        ]
    })

    const myOffcanvas = document.getElementById('offcanvasTransaction')
    offcanvasTransactionModal = new bootstrap.Offcanvas(myOffcanvas)

    myOffcanvas.addEventListener('shown.bs.offcanvas', function () {
        formEdited = false
    })

    myOffcanvas.addEventListener('hidden.bs.offcanvas', function () {
        if (!formEdited || $('#f_account').val() === null)
            return

         const params = {
            item: {
                _id: $('#_id').val(),
                statistic: $('#f_statistic').prop('checked'),
                paid: $('#f_paid').prop('checked'),
                transactionAmount: {
                    amount: $('#f_amount').val() || 0,
                    currency: globals.vars.userData.accountsById[$('#f_account').val()]['currency']
                },
                date: { reported: moment($('#f_date').val()).toISOString() },
                accountId: $('#f_account').val(),
                categoryId: $('#f_category').val(),
                tags: $('#f_tags').val(),
                title: $('#f_title').val(),
                receiver: $('#f_receiver').val(),
                usage: $('#f_usage').val(),
                comment: $('#f_comment').val(),
                isDuplicate: $('#f_duplicate').prop('checked'),
            },
            _csrf: $("meta[name=_csrf]").attr("content")
        }

        const _url = $('#delete-transaction-btn').is(':visible') ? '/json/transaction/update' : '/json/transaction/insert'

        $.ajax({
            url: _url,
            method: 'POST',
            data: params,
            success: function (response) {
                if (typeof response['error'] !== 'undefined') {
                    helpers.alert(response)
                }

                if (DEBUG) console.log(response)
    
                dataTable.ajax.reload().draw('full-hold')
            },
            error: function (err) {
                helpers.alert(err)
            }
        }); 
    })


    //ANCHOR - Category picker
    function categoryPicker(d) {
        let output = `<div class="d-flex flex-wrap border border-light ms-2">`

        for (const category of Object.values(globals.vars.userData.categories)) {
            const cls = d.categoryId == category['_id'] ? ' border border-3 border-primary' : ''
            output += `<div class="text-center p-1 m-1${cls} category-picker" data-category="${category['_id']}"><div class="d-flex flex-column" title="${category['name']}"><i class="${category['icon']} fa-2x fs-1 text-muted"></i><div class="cat-icons-name mt-1">${category['name']}</div></div> </div>`
        }

        output += `<div class="text-center p-1 m-1 category-picker" data-category=""><div class="d-flex flex-column" title="${global.i18n.t('dashboard.empty_accountType')}"><i class="fas fa-question-circle fa-2x fs-1 text-muted"></i><div class="cat-icons-name mt-1 text-danger">${global.i18n.t('dashboard.empty_accountType')}</div></div> </div>`
        output += '</div>'
        
        return output
    }

    $('#transactions-datatable tbody').on('click', 'td.col-category', function (e) {        
        e.preventDefault()
        e.stopImmediatePropagation()

        var tr = $(this).closest('tr');
        var row = dataTable.row(tr);

        if (row.data()['isAccountBalance'] == true)
            return


        e.preventDefault();
        if (row.child.isShown()) {
            // This row is already open - close it
            row.child.hide();
        } else {
            dataTable.rows().every( function ( rowIdx, tableLoop, rowLoop ) {
                // @ts-expect-error n/a
                const r = this
                if (r.child.isShown())
                    r.child.hide()
            } );

            // Open this row
            row.child(categoryPicker(row.data())).show();
 
            $('.category-picker').off().on('click', function(e) {
                e.preventDefault()

                row.child.hide()

                const params = {
                    item: {
                        _id: row.data()['_id'],
                        categoryId: $(this).attr('data-category')
                    }
                }

                document.addEventListener(`update-transaction`, function callback() {
                    if (DEBUG) console.log((`Event received: update-transaction`))
    
                        dataTable.ajax.reload().draw('full-hold')
                    document.removeEventListener(`update-transaction`, callback)
                })

                helpers.updateTransaction(params, false)
            })
        }
    })

    $('#transactions-datatable tbody').on('dblclick', 'tr', function (e) {        
        e.preventDefault()

        if ($('.searchInput').is(':visible') || $('#filter_unpaid').is(':visible'))
            return

        var row = dataTable.row($(this))

        const data = row.data()

        if (data.length == 0)
            return

        // if (data.pending == true)
        //     return

        if (data.isAccountBalance) {
            $('#selectTop').val(data.accountId)
            $('#selectTop').trigger('change')

            $('#deleteAccBalBtn').show()
            $('#accBal_id').val(data._id)
            $('#accBalAmount').val(parseFloat(data.transactionAmount.amount))
            $('#accBalCurrency').val(data.transactionAmount.currency)
            $('#accBalDate').data('daterangepicker').setStartDate(moment(data.date.booked).local().format('YYYY-MM-DD HH:mm:ss'))
            $('#accBalComment').val(data.comment)
            $('#account-balance-modal').modal('show')
            return
        }

        currentEditedTransaction = data

        fillTransactionEditModal(data)
        $('#_id').val(data._id)

        $('#copy-transaction-btn').show()
        $('#delete-transaction-btn').show()
        
        offcanvasTransactionModal.show()

    })

    $('#filterErase').off().on('click', function(e) {
        e.preventDefault()

        _.map(swArr, function(o) {
            $(o).prop('checked', false)
        })

        $('#activeFilters').text('')

        helpers.appSettingsDelete('transactionsFilters')

        applyDataFilters()
    })

    $('#filter_duplicates').off().on('change', function() {
        dataTable.ajax.reload().draw('full-hold')
    })

    _.map(swArr, function(o) {
        $(o).off().on('change', function() {
            if ($(o).attr('id') == 'filter_income' && $(o).prop('checked'))
                $('#filter_expenses').prop('checked', false)

            if ($(o).attr('id') == 'filter_expenses' && $(o).prop('checked'))
                $('#filter_income').prop('checked', false)
           
            setTimeout(function() {
                const count = _.filter(swArr, function(o) {
                    return $(o).prop('checked') === true
                })

                helpers.appSettingsSet({'transactionsFilters': count})
           
                if (count.length == 0)
                    $('#activeFilters').text('')
                else
                    $('#activeFilters').text(`(${global.i18n.t('transactions.datatables.filtered')})`)
            }, 50)
        
            $('#dateInfoTitle').text(`${global.i18n.t('transactions.dateRangePicker.from')} ${sDate.toLocaleDateString(globals.vars.locales)} ${global.i18n.t('transactions.dateRangePicker.to')} ${eDate.toLocaleDateString(globals.vars.locales)}`)

            applyDataFilters()
        })
    })
}

